import {newE2EPage, E2EPage} from '@stencil/core/testing';

describe('select e2e', () => {
    it('should simply check that options slot are rendered in the right place', async () => {
        // Basic test to bullet-proof the slot rendering
        const page: E2EPage = await newE2EPage();
        await page.setContent(`
            <joy-select value="second" label="I am a label">
                <option disabled value="">Choose an option</option>
                <option value="one">One</option>
                <option value="second">One</option>
            </joy-select>
        `);

        const select = await page.find('select');
        const options = await select.findAll('option');
        expect(options.length).toEqual(3);
    });

    it('should apply value to native select when adding a value property on joy-select', async () => {
        const page: E2EPage = await newE2EPage();
        await page.setContent(`
            <joy-select value="second">
                <option value="one">One</option>
                <option value="second">Two</option>
                <option value="three">Three</option>
            </joy-select>
        `);

        const select = await page.find('select');
        expect(await select.getProperty('value')).toEqual('second');
    });
});
